import React from 'react';
import { cx } from '../cx';

// D-07 §21.3 — 중앙 컬럼 최대폭. sm 480 / md 720 / lg 1060(기본) / xl 1440 / full 제한없음.
// 페이지 폭의 정본은 <Page width>. 고르기 어려우면 D-07 §21.5 PC 레이아웃 10유형(/ui-standard Layout 절) 참고
export type PageWidth = 'sm' | 'md' | 'lg' | 'xl' | 'full';

/** PageWidth → components.css 클래스. full 은 폭 제한이 없으므로 빈 문자열 */
export const pageWidthClass = (w: PageWidth) => (w === 'full' ? '' : `lay-w-${w}`);

// D-07 §21.4 — Page (.page + .page-doc | .page-fixed)
export interface PageProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * 스크롤 소유권. 이 값이 페이지 골격을 결정한다.
   * - `doc`(기본): 스크롤 소유자는 AppFrame 의 `<main>`. 페이지는 내용만큼 자연 증가한다.
   * - `fixed`: 페이지가 `<main>` 높이를 채우고, 내부 `<PageScroll>` 이 스크롤을 다시 만든다.
   *   툴바·필터바·푸터를 고정해야 하거나 캔버스가 남은 높이를 다 먹어야 할 때 쓴다.
   */
  layout?: 'doc' | 'fixed';
  /**
   * 중앙 컬럼 최대폭. `doc` 전용 — `fixed` 에서는 폭을 내부 `<PageScroll>` 이 갖는다.
   * (규칙: 스크롤을 가진 쪽이 폭과 패딩을 가진다)
   */
  width?: PageWidth;
  /** 페이지 패딩(32px). `doc` 기본 true / `fixed` 기본 false */
  pad?: boolean;
}

export function Page({
  layout = 'doc',
  width = 'lg',
  pad,
  className = '',
  children,
  ...props
}: PageProps) {
  const isDoc = layout === 'doc';
  return (
    <div
      className={cx(
        'page',
        isDoc ? 'page-doc' : 'page-fixed',
        (pad ?? isDoc) && 'page-pad',
        isDoc && pageWidthClass(width),
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
